import { registerPlugin } from '@capacitor/core';
const NetWork = registerPlugin('NetWork', {
    web: () => import('./web').then(m => new m.NetWorkWeb()),
});
export * from './definitions';
export { NetWork };
//# sourceMappingURL=index.js.map